
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({components:{}})
export default class MaintenanceItemName extends Vue {

  @Prop({required: true}) readonly data !: any

}
